import { Button, Col, Form, message, Modal, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ControlledSelect from "../../../../../components/Backoffice/ControlledSelectV1";
import ControlledInput from "../../../../../components/Backoffice/ControlledInput";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../slice";
import * as selectors from "../selectors";

const schema = yup.object().shape({
  lab: yup.string().required("Lab is required"),
  logistic: yup.string().required("Logistic is required"),
  trackingId: yup.string().notRequired(),
});

function AssignLabAndLogistic({
  orderDetails,
  isLabAndLogisticModalVisible,
  setIsLabAndLogisticModalVisible,
  setUpdateOrderStatusModalVisible,
}) {
  const { orderId } = orderDetails;
  const dispatch = useDispatch();
  const labs = useSelector(selectors.selectLabs) || [];
  const logisticsPartners = useSelector(selectors.selectLogisticPartners);
  const [isLoading, setIsLoading] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      lab: "",
      logistic: "",
      trackingId: "",
    },
  });

  const labOptions = () =>
    labs.map((lab) => ({ label: lab.name, value: lab._id }));

  const logisticsOptions = () =>
    logisticsPartners && logisticsPartners.length
      ? logisticsPartners.map((logistic) => ({
          label: logistic.name,
          value: logistic._id,
        }))
      : [];

  useEffect(() => {
    dispatch(actions.fetchLogisticPartners());
    dispatch(actions.fetchLabs());
  }, [dispatch]);

  useEffect(() => {
    if (orderDetails) {
      reset({
        lab: orderDetails.assignedLab?._id || "",
        logistic: orderDetails.assignedLogistics?._id || "",
        trackingId: orderDetails.trackingId || "",
      });
    }
  }, [orderDetails, reset, isLabAndLogisticModalVisible]);

  const handleAssignLabAndLogistic = (data) => {
    const isSameLab = (orderDetails.assignedLab?._id || "") === data.lab;
    const isSameLogistic =
      (orderDetails.assignedLogistics?._id || "") === data.logistic;
    const isSameTrackingId =
      (orderDetails.trackingId || "") === data.trackingId;

    if (isSameLab && isSameLogistic && isSameTrackingId) {
      setIsLabAndLogisticModalVisible(false);
      setUpdateOrderStatusModalVisible(true);
      return;
    }

    const labData = [
      {
        orderId: orderId,
        labToBeAssignedId: data.lab,
      },
    ];

    const logisticData = [
      {
        orderId: orderId,
        logisticId: data.logistic,
        trackingId: data.trackingId,
      },
    ];
    setIsLoading(true);
    dispatch(
      actions.assignLabAndLogistic({
        labData,
        logisticData,
        same: {isSameLab, isSameLogistic, isSameTrackingId},
        id: orderDetails?._id,
        onSuccess: () => {
          message.success(`Lab and Logistic data assigned successfully`);
          //   notification.success({
          //     message: "Lab and Logistic Assigned Successfully",
          //   });
          setIsLoading(false);
          setIsLabAndLogisticModalVisible(false);
          setUpdateOrderStatusModalVisible(true); 
        },
        onFailure: () => {
          message.error(`Failed to assign Lab and Logistic data`);
          setIsLoading(false);
          //   notification.error({
          //     message: "Failed to Assign Lab and Logistic",
          //   });
        },
      })
    );
  };

  return (
    <>
      <Modal
        title="Assign & Continue"
        visible={isLabAndLogisticModalVisible}
        onCancel={() => {
          setIsLabAndLogisticModalVisible(false);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsLabAndLogisticModalVisible(false);
            }}
          >
            Cancel
          </Button>,
          <Button
            type="primary"
            loading={isLoading}
            onClick={handleSubmit(handleAssignLabAndLogistic)}
          >
            Assign & Continue
          </Button>,
        ]}
      >
        <div
          style={{
            background: "#fffbe6",
            border: "1px solid #ffe58f",
            borderRadius: 4,
            padding: "12px 16px",
            marginBottom: 16,
            display: "flex",
            alignItems: "center",
          }}
        >
          <span style={{ color: "#ad8b00", fontWeight: 500, fontSize: 15 }}>
            Before transitioning from
            <span
              style={{ color: "#1890ff", fontWeight: 600, margin: "0 4px" }}
            >
              "In Review"
            </span>
            to
            <span
              style={{ color: "#52c41a", fontWeight: 600, margin: "0 4px" }}
            >
              "Ready for Pickup"
            </span>
            , please ensure that Lab and Logistics data are assigned to the
            order.
          </span>
        </div>
        <Form colon={false}>
          <Row gutter={0}>
            <Col span={24}>
              <ControlledSelect
                required
                control={control}
                name="lab"
                label="Select Lab"
                options={labOptions()}
                errors={errors}
                // fullLabelWidth={true}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <ControlledSelect
                required
                control={control}
                name="logistic"
                label="Select Logistic"
                options={logisticsOptions()}
                errors={errors}
                // fullLabelWidth={true}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                control={control}
                name="trackingId"
                label="Tracking ID"
                errors={errors}
                // fullLabelWidth={true}
              />
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default AssignLabAndLogistic;
